import { createSelector } from "reselect";
import getElementStatusFilter from "./get_element_status_filter";

const getDetectedDeviationsShown = createSelector([
  getElementStatusFilter
], (filter) => filter.detectedDeviationsShown);

export default getDetectedDeviationsShown;
